/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface FirmView
 */
export interface FirmView {
    /**
     * 
     * @type {string}
     * @memberof FirmView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmView
     */
    name?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof FirmView
     */
    address?: Address;
}

export function FirmViewFromJSON(json: any): FirmView {
    return FirmViewFromJSONTyped(json, false);
}

export function FirmViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
    };
}

export function FirmViewToJSON(value?: FirmView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': AddressToJSON(value.address),
    };
}


